export class ApiError extends Error {
  status: number;
  payload: any;
  constructor(message: string, status: number, payload: any) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

async function readJsonSafe(resp: Response) {
  const text = await resp.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export async function apiGet<T>(path: string): Promise<T> {
  const resp = await fetch(path, { credentials: 'include' });
  const payload = await readJsonSafe(resp);
  if (!resp.ok) throw new ApiError('Request failed', resp.status, payload);
  return payload as T;
}

export async function apiPost<T>(path: string, body?: any): Promise<T> {
  const resp = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: body == null ? undefined : JSON.stringify(body),
  });
  const payload = await readJsonSafe(resp);
  if (!resp.ok) throw new ApiError('Request failed', resp.status, payload);
  return payload as T;
}

export async function apiPatch<T>(path: string, body?: any): Promise<T> {
  const resp = await fetch(path, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: body == null ? undefined : JSON.stringify(body),
  });
  const payload = await readJsonSafe(resp);
  if (!resp.ok) throw new ApiError('Request failed', resp.status, payload);
  return payload as T;
}

export async function apiDelete<T>(path: string): Promise<T> {
  const resp = await fetch(path, {
    method: 'DELETE',
    credentials: 'include',
  });
  const payload = await readJsonSafe(resp);
  if (!resp.ok) throw new ApiError('Request failed', resp.status, payload);
  return payload as T;
}
